import { FONT_BASE } from '../../constants/AppFonts';

export class ButtonComposited extends Phaser.GameObjects.Container {
  constructor(scene, opts) {
    super(scene);

    this.text = scene.add
      .text(
        0,
        opts.buttonType === 'secondary' ? -8 : 0,
        opts.copyid ? scene.game.copy.get(opts.copyid) : opts.text,
        {
          fontFamily: opts.font || FONT_BASE.TITLE,
          fontSize: opts.fontSize || 30,
          color: '#FFFFFF',
          align: 'center',
        }
      )
      .setOrigin(0.5);

    this.icon = scene.add
      .image(this.text.x + this.text.width * 0.5 + 20, this.text.y, 'buttons', opts.icon)
      .setOrigin(0, 0.5);
    if (!opts.icon) {
      this.icon.displayWidth = 0;
      this.icon.visible = false;
    } else {
      this.text.x -= this.icon.displayWidth * 0.5 + 10;
      this.icon.x -= this.icon.displayWidth * 0.5 + 10;
    }

    // add mid panel and set width
    this.mid = scene.add.image(0, 0, 'buttons', 'btn_' + opts.buttonType + '_mid');
    this.mid.displayWidth = this.icon.displayWidth + 20 + this.text.displayWidth;

    // add left panel and position
    this.left = scene.add.image(0, 0, 'buttons', 'btn_' + opts.buttonType + '_left');
    this.left.x = -this.mid.displayWidth * 0.5 - this.left.displayWidth * 0.5;

    // add right panel and position
    this.right = scene.add.image(0, 0, 'buttons', 'btn_' + opts.buttonType + '_right');
    this.right.x = this.mid.displayWidth * 0.5 + this.right.width * 0.5;

    this.fullWidth = this.mid.displayWidth + this.left.displayWidth + this.right.displayWidth;
    this.fullHeight = this.mid.height;
    this.iconType = opts.icon;
    this.buttonType = opts.buttonType;
    this.textColour = opts.colour;
    // opts.clickSFX = { sprite: 'sfx', id: 'button', volume: 0.3 };

    this.add([this.left, this.mid, this.right, this.icon, this.text]);
    // this.x = x - this.fullWidth / 2;
    this.y = opts.y;
    this.x = opts.x;
    this.id = opts.id;
    scene.add.existing(this);
    this.enableInteractive();
    this.on('pointerover', this.onPointerOver, this);
    this.on('pointerout', this.onPointerOut, this);
    this.on('pointerdown', this.onPointerClick, this);
  }

  get width() {
    return this.fullWidth;
  }

  get displayWidth() {
    return this.fullWidth;
  }

  get height() {
    return this.fullHeight;
  }
  get displayHeight() {
    return this.fullHeight;
  }

  onPointerOver() {
    this.left.setFrame('btn_' + this.buttonType + '_left_over');
    this.mid.setFrame('btn_' + this.buttonType + '_mid_over');
    this.right.setFrame('btn_' + this.buttonType + '_right_over');
    if (this.icon.visible) this.icon.setFrame(this.iconType + '_over');
    this.text.setColor(this.textColour);
  }

  onPointerOut() {
    this.left.setFrame('btn_' + this.buttonType + '_left');
    this.mid.setFrame('btn_' + this.buttonType + '_mid');
    this.right.setFrame('btn_' + this.buttonType + '_right');
    if (this.icon.visible) this.icon.setFrame(this.iconType);
    this.text.setColor('#ffffff');
  }

  onPointerClick() {
    this.emit('click', this);
  }

  enableInteractive() {
    this.setInteractive({
      useHandCursor: true,
      hitArea: new Phaser.Geom.Rectangle(0, 0, this.fullWidth, this.mid.displayHeight),
      hitAreaCallback: Phaser.Geom.Rectangle.Contains,
    });
  }

  destroy() {
    super.destroy();
  }
}
